/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1ExamQuestionLibraryItemExamitemidQueryResponse,
  GetApiV1ExamQuestionLibraryItemExamitemidPathParams,
  GetApiV1ExamQuestionLibraryItemExamitemid401,
  GetApiV1ExamQuestionLibraryItemExamitemid404,
  GetApiV1ExamQuestionLibraryItemExamitemid500,
} from "../../types/examQuestionLibraryController/GetApiV1ExamQuestionLibraryItemExamitemid.ts";

function getGetApiV1ExamQuestionLibraryItemExamitemidUrl(
  examItemId: GetApiV1ExamQuestionLibraryItemExamitemidPathParams["examItemId"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/exam/question-library/item/${examItemId}` as const,
  };
  return res;
}

/**
 * @description Retorna todas as informações de uma questão da biblioteca pelo seu identificador, incluindo tipo de componente, enunciado, configurações, idioma, status e, quando aplicável, as opções da lista de respostas. **(Requer Authorization para autenticação)**
 * @summary Obter detalhes completos de uma questão (Requer Authorization para autenticação)
 * {@link /api/v1/exam/question-library/item/:examItemId}
 */
export async function getApiV1ExamQuestionLibraryItemExamitemid(
  examItemId: GetApiV1ExamQuestionLibraryItemExamitemidPathParams["examItemId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1ExamQuestionLibraryItemExamitemidQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ExamQuestionLibraryItemExamitemid401
      | GetApiV1ExamQuestionLibraryItemExamitemid404
      | GetApiV1ExamQuestionLibraryItemExamitemid500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1ExamQuestionLibraryItemExamitemidUrl(
      examItemId,
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
